<div
  class="relative flex flex-col items-center justify-center gap-3 h-full w-full"
>
  <div class="relative w-full h-full">
    @for (image of images(); track image; let i = $index) {
    <div
      class="absolute inset-0 transition-opacity duration-1000 ease-in-out"
      [ngClass]="{
        'opacity-0': currentImageIndex !== i,
        'opacity-100': currentImageIndex === i
      }"
    >
      <img
        class="h-full w-full rounded-3xl object-cover"
        [src]="image | placeholder"
      />
    </div>
    }
  </div>
  @if (title || description) {
  <div class="w-full flex justify-between">
    <span>{{ title }} </span>
    <span class="font-semibold">{{ description }}</span>
  </div>
  } @if (showImageIndex) {
  <div class="absolute bottom-14 left-0 right-0 flex justify-center space-x-2">
    @for (image of images(); track image; let i = $index) {
    <div
      class="w-3 h-3 rounded-full"
      [ngClass]="currentImageIndex === i ? 'bg-green-30' : 'bg-gray-300'"
    ></div>
    }
  </div>
  } @if (showSlideButton()) {
  <div class="h-full w-full flex justify-between p-8 items-center absolute">
    <div
      class="h-8 w-8 flex items-center justify-center border border-gray-seed rounded-full"
      [ngClass]="{
        'hover:bg-white hover:border-white cursor-pointer':
          currentImageIndex > 0
      }"
      (click)="slideLeft()"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 6C15 6 9.00001 10.4189 9 12C8.99999 13.5812 15 18 15 18"
          stroke="#A9A9A9"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div
      class="h-8 w-8 flex items-center justify-center border border-gray-seed rounded-full"
      [ngClass]="{
        'hover:bg-white hover:border-white cursor-pointer':
          currentImageIndex < images().length - 1
      }"
      (click)="slideRight()"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.00005 6C9.00005 6 15 10.4189 15 12C15 13.5812 9 18 9 18"
          stroke="#A9A9A9"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
  }
</div>
